<template>
  <div>

    <div id="account-wrap" class="row" v-if="$root.user.isAdmin">

    <div 
    class="avatar" 
    :class="subscription.icon ? 'avatar--' + subscription.icon : 'avatar--placeholder'">
    </div>
      <div class="account-info">
        <div class="table">
          <div class="cell">
            <div class="account-info__title">{{ user.fullName ? user.fullName : 'Wordt geladen...' }}</div>
            <div class="account-info__subtitle">Klantnummer {{ user.poc }}</div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="$root.user.loginType === 'web' && $root.app.platform == 'desktop'">
      <div class="row spacer" v-if="$root.app.platform == 'ios' && $root.user.isAdmin">&nbsp;</div>
      <div class="row row-button">
        <div class="col col-100" @click="logout()">
          <button class="button signout">Uitloggen</button>
        </div>
      </div>
    </div>


    <div class="row head" v-if="hasSms">
      <div class="row-wrap">
        <div class="rows" v-if="$root.user.active">
            <div class="row row-single setting">
              <router-link to="/messages">
                <div v-if="$root.app.platform == 'ios'" class="col col-100">
                        <span class="row__title">Berichten</span>
                </div>
              </router-link>
            </div>
        </div>
      </div>
    </div>
    

    <div class="row-wrap">
      <div class="row head" v-if="$root.app.platform == 'ios'">
        <div class="col col-100">Accountgegevens</div>
      </div>

      <div class="rows" v-if="$root.user.active">
        <div class="row row-first setting outgoing-number">
          <!-- <router-link to="/numbers"> -->
          <div v-if="$root.app.platform == 'android'" class="col col-100">
            <span class="row__title">Uitgaand nummer</span><br/>
            <span class="row__subtitle">
                                <select @change="changedValue($event)" v-model="numberIndex">
                                    <option v-for="phoneNumber in phoneNumbers" :key="phoneNumber.id"
                                            v-bind:value="phoneNumber.number_id">
                                        {{ phoneNumber.phoneNumber + ' (' + phoneNumber.name + ')' }}
                                    </option>
                                </select>
                            </span>

          </div>
          <div v-if="$root.app.platform == 'ios'" class="col col-50">
            <span class="row__title">Uitgaand nummer</span>
          </div>
          <div v-if="$root.app.platform == 'ios'" class="col col-50">
                            <span class="row__subtitle">
                                <select @change="changedValue($event)" v-model="numberIndex">
                                    <option v-for="phoneNumber in phoneNumbers" :key="phoneNumber.id"
                                            v-bind:value="phoneNumber.number_id">
                                        {{ phoneNumber.phoneNumber + ' (' + phoneNumber.name + ')' }}
                                    </option>
                                </select>
                            </span>
          </div>
          <!-- </router-link> -->
        </div>
        <div v-if="$root.user.isAdmin" class="row setting has-subitem">
          <router-link to="/email-edit">
            <div v-if="$root.app.platform == 'android'" class="col col-100">
              <span class="row__title">E-mailadres</span><br/>
              <span class="row__subtitle">{{ user.email ? truncate(user.email, 20) : '...' }}</span>

            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
              <span class="row__title">E-mailadres</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
              <span class="row__subtitle">{{ user.email ? truncate(user.email, 20) : '...' }}</span>
            </div>
          </router-link>
        </div>

        <div v-if="subscription.accessType == '3'">
          <div class="row row-last setting has-subitem">
            <router-link to="/credit">
              <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Tegoed / Verlengen</span><br/>
                <span class="row__subtitle">Je bundel loopt tot {{ creditData.endDate ? creditData.endDate : '...' }}</span>
              </div>
              <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Tegoed / Verlengen</span>
              </div>
              <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__subtitle">Je bundel loopt tot<br>{{ creditData.endDate ? creditData.endDate : '...' }}</span>
              </div>
            </router-link>
          </div>
        </div>


        <div v-if="subscription.accessType == '1'">
          <div class="row setting has-subitem">
            <router-link to="/numbers">
              <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Nummer instellingen</span><br/>
              </div>
              <div v-if="$root.app.platform == 'ios'" class="col col-100">
                <span class="row__title">Nummer instellingen</span>
              </div>
            </router-link>
          </div>

          <div class="row setting has-subitem" v-if="$root.user.isAdmin"
               :class="{'setting--nb': subscription.status != 'active' && $root.app.platform == 'ios'}">
            <router-link to="/subscriptions">
              <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Abonnement</span><br/>
                <span class="row__subtitle">{{ subscription.name }}</span>
              </div>
              <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Abonnement</span>
              </div>
              <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__subtitle">{{ subscription.name }}</span>
              </div>
            </router-link>
          </div>

        </div>


        <div class="row row-last explanation explanation--bb" v-if="subscription.status != 'active'">
          <div v-if="subscription.status == 'cancelled'">

            <!-- Subscription to be cancelled -->

            Je abonnement is opgezegd op <strong>{{ subscription.cancelTime }}</strong> en verloopt op
            <strong>{{ subscription.expireTime }}</strong>.
          </div>
          <div v-else>

            <!-- Subscription cancelled -->

            Je abonnement is verlopen op <strong>{{ subscription.cancelTime }}</strong>. Wil je een nieuw abonnement?
            Neem dan contact op met onze helpdesk.
          </div>
        </div>

        <div v-if="subscription.accessType == '1'">
          <div class="row row-last setting has-subitem" v-if="$root.user.isAdmin">
            <router-link :to="{ name: 'account/bundles-overview', params: { poc: $root.user.poc }}">
              <div class="col col-100">
                <span class="row__title">Bundels</span>
              </div>
            </router-link>
          </div>
        </div>

      </div>
      <div v-else>
        <div class="row setting explanation">
          <strong>Inactief account</strong><br>
          Je account heeft geen actief abonnement. Wil je een nieuw abonnement? Neem dan contact op met onze helpdesk
          via 'Ondersteuning'.
        </div>
      </div>
    </div>

    <div class="row spacer" v-if="$root.app.platform == 'ios' && subscription.status == 'active'">&nbsp;
    </div>

    <div class="row row-first setting has-subitem" v-if="$root.user.isAdmin">
      <router-link to="/account">
        <div class="col col-100">
          <span class="row__title">Persoonlijke gegevens</span>
        </div>
      </router-link>
    </div>
    <div class="row setting has-subitem" v-if="$root.user.isAdmin">
      <router-link to="/usage">
        <div class="col col-100">
          <span class="row__title">Verbruik</span><br/>
        </div>
      </router-link>
    </div>
    <div class="row setting has-subitem" v-if="$root.user.isAdmin">
      <router-link to="/blacklist">
        <div class="col col-100">
          <span class="row__title">Blokkades</span><br/>
        </div>
      </router-link>
    </div>
    <div class="row setting has-subitem" v-if="$root.user.isAdmin">

      <router-link to="/invoices">
        <div class="col col-100">
          <span class="row__title">Facturen</span>
        </div>
      </router-link>
    </div>

    <div class="row setting has-subitem" v-if="$root.user.isAdmin">
      <router-link to="/settings">
        <div class="col col-100">
          <span class="row__title">Configuratie</span>
        </div>
      </router-link>
    </div>
    <div class="row row-last setting has-subitem" v-if="$root.user.isAdmin">
      <router-link to="/feedback">
        <div class="col col-100">
          <span class="row__title">Ondersteuning</span>
        </div>
      </router-link>
    </div>

    <div v-if="$root.user.loginType === 'web' && $root.app.platform == 'ios' ||  $root.app.platform == 'android'">
      <div class="row spacer" v-if="$root.app.platform == 'ios' && $root.user.isAdmin">&nbsp;</div>
      <div class="row row-button">
        <div class="col col-100" @click="logout()">
          <button class="button signout">Uitloggen</button>
        </div>
      </div>
    </div>

    <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>

  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {

    return {
      user: {},
      hasSms: null,
      phoneNumber: null,
      subscription: {},
      phoneNumbers: [],
      numberIndex: null,
      creditData: {},
    }
  },

  mounted() {

    this.getPhoneNumbers();
  },

  created() {
  var root = this.$root;

    this.$api.get('/dashboard')
      .then(response => {
        this.user = response.data.user;
        this.hasSms = response.data.hasSms;
        this.phoneNumber = response.data.phoneNumber;
        this.subscription = response.data.subscription;

        // 🔹 Extra API call als accessType == 3
        if (this.subscription.accessType == 3) {
          this.$api.get('/credit')
            .then(res => {
              this.creditData = res.data
            })
            .catch(e => {
              console.error("Error loading credit data:", e)
            })
        }

        root.loading = false;
      })
      .catch(e => {
        console.error("Error loading dashboard:", e)
      })
  },


  methods: {

    
    truncate(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '…' : text;
    },



    getPhoneNumbers() {

      this.$api.get('/numbers')
        .then(response => {
          this.phoneNumbers = response.data.phoneNumbers;
          for (const property in this.phoneNumbers) {
            if (this.phoneNumbers[property].active == 1) {
              this.numberIndex = property;
            }
          }
        })
        .catch(e => {

        })
    },

    changedValue: function (event) {
      console.log('test');
      this.$api.post('/settings', {
        action: 'switch-default-number',
        phoneNumberID: event.target.value
      })
        .then(response => {


        })
        .catch(e => {


        })
    },

    logout() {

      this.$auth.logout();
    },

    // showEmail(e){

    //     window.ui.showDialog(
    //         'E-mailadres',
    //         e+' <span class="note">Wijzigen? Maak een support ticket aan. Wij helpen je graag verder.</span>',
    //         true
    //     );
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue